import JChartDonut from './Control_Charts'
export { JChartDonut }
export default JChartDonut
